import { useEffect, useState } from 'react';
import CardFrom, { CardFormConfig } from '../../component/card/card-from';
import i18n from '../../i18n';
import ButtonComponent from '../../component/button/button.component';
import LSM from '../../modules/cache/tool-local-storage';
import { LOCAL_STORAGE_KEYS } from '../../modules/cache/local-storage.constant';
import { Admin } from '../../models';
import apiManage from '../../request';
import GlobalNotification from '../../component/common/snackbar';
import _ from 'lodash';
import { Box } from '@mui/material';

export default function DataBubblePage() {
    // 原始用户信息
    const [userInfo, setUserInfo] = useState<Admin>({})
    // 编辑后的用户信息
    const [editUserInfo, setEditUserInfo] = useState<Pick<Admin, 'databubble_account' | 'databubble_password' | 'databubble_prefix'>>({});
    useEffect(() => {
        init()
    }, [])

    const init = () => {
        getUserInfo();
    }

    const getUserInfo = async () => {
        const account = LSM.get(LOCAL_STORAGE_KEYS.ACCOUNT) || {};
        const userInfo = await apiManage.get_admin_id_id(account._id || '');
        if (!userInfo?.error) {
            setUserInfo(userInfo);
            setEditUserInfo(_.pick(userInfo, ['databubble_account', 'databubble_password', 'databubble_prefix']));
        }
    }

    /**
     * 表单回调
     * @param value
     * @param key
     */
    const onFormChange = (value: string, key: string) => {
        editUserInfo[key] = value
        setEditUserInfo({ ...editUserInfo })
    }


    /**
     * 保存表单
     */
    const onFormSave = async () => {
        const newAccount = {
            _id: userInfo._id,
            ...editUserInfo,
            // 默认39
            databubble_prefix: editUserInfo.databubble_prefix || '39',
            databubble_key: undefined
        }
        const result = await apiManage.patch_admin_id_admin(newAccount)
        if (result && !result?.error) {
            GlobalNotification.success(`${i18n.t('dish_book_msg_save_success')}`);
            getUserInfo()
        } else {
            GlobalNotification.error(`${i18n.t('dish_book_msg_save_failed')}`);
        }
    }


    // 表单
    const formData = [
        {
            key: 'databubble_prefix',
            label: i18n.t('general_text_country_code'),
            inputType: 'COUNTRY_SELECT' as const,
            xs: 12,
            md: 3,
        },
        {
            key: 'databubble_account',
            label: i18n.t('general_text_phone'),
            xs: 12,
            md: 9,
        },
        {
            key: 'databubble_password',
            label: i18n.t('login_page_text_password'),
            xs: 12,
            md: 12,
        }
    ]

    // 表单
    const cardConfig: CardFormConfig[] = [{
        md: 12,
        columnSpacing: { xs: 2 },
        rowSpacing: 2,
        key: 'base_setting_title',
        title: i18n.t('base_setting_title'),
        actionRender: (
            <ButtonComponent
                action='SAVE'
                handleClick={() => onFormSave()}
                async={true}
            />
        ),
        children: formData.map((item) => (
            {
                key: item.key,
                label: item.label,
                comType: 'INPUT',
                inputType: item.inputType,
                xs: item.xs,
                md: item.md,
                inputIsEdited: userInfo[item.key] !== editUserInfo[item.key],
                onChange: (e) => onFormChange(e.target.value, item.key),
                handleChangeCountry: (value) => onFormChange(value, item.key),
            }
        ))
    }]

    return (
        <Box sx={{ maxWidth: 500 }}>
            <CardFrom
                config={cardConfig}
                data={editUserInfo}
            />
        </Box>
    )
}